import { storeToRefs } from "pinia";

export const useFetchCategoryTree = () => {
	const { getCategoryTree } = useNorcePwa();
	const { categoryTree } = storeToRefs(useCategoryStore());

	const fetchCategoryTree = async (locale: string) => {
		let categories = categoryTree.value[locale];
		if (!categories?.length) {
			categories = await getCategoryTree({
				...useNorceStore().storeContext
			});
			useCategoryStore().setCategoryTree({ [locale]: categories });
		}

		return categories;
	};

	return { fetchCategoryTree };
};
